// Content model for the SGOKit platform marketing site. Voice: mission-forward,
// aspirational present — the site speaks as if the whole toolkit is real. The
// plans for making each claim true live OUTSIDE the app, in docs/plans/.
import type { IconKey } from './icons';

export const NAV = [
  { to: '/platform', label: 'Platform' },
  { to: '/footprint', label: 'Footprint' },
  { to: '/site', label: 'Your site' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/about', label: 'Mission' },
];

export const HERO_STATS: { num: string; sup?: string; lbl: string }[] = [
  { num: '$1,700', lbl: 'Federal S25F credit per donor, beginning 2027' },
  { num: '51', lbl: 'States + DC, each configured on your own map' },
  { num: '0', sup: '%', lbl: 'Our cut of your donations — fees pass straight through' },
  { num: '5', sup: '%', lbl: 'Membership capped at 5% of donations, or $500/mo' },
];

// The toolkit — "what's in the box." Order is the donor-to-scholar lifecycle.
export const MODULES: { icon: IconKey; title: string; blurb: string; to: string }[] = [
  { icon: 'donations', title: 'Donations', to: '/platform',
    blurb: 'Collect and track gifts on day one. Stripe Connect deposits straight into your account — we never touch the money.' },
  { icon: 'applications', title: 'Applications', to: '/platform',
    blurb: 'Take scholarship applications with eligibility criteria you define — income, geography, school type, your own rules.' },
  { icon: 'scoring', title: 'Objective scoring', to: '/platform',
    blurb: 'Score applicants on a quantitative rubric so selection is defensible, repeatable, and free of guesswork.' },
  { icon: 'disbursement', title: 'Disbursement', to: '/platform',
    blurb: 'Award and pay scholarships to families and schools, with every dollar tracked from gift to grant.' },
  { icon: 'compliance', title: 'S25F guardrails', to: '/platform',
    blurb: 'Income caps, no double-dipping, state opt-in — the rules of the federal credit are checked for you as you go.' },
  { icon: 'footprint', title: 'State footprint', to: '/footprint',
    blurb: 'Configure your posture in all 51 jurisdictions and publish a live map of exactly where donors earn the credit.' },
];
